import { useSelector } from 'react-redux';

import { SortDirection } from '@air/api/types';

import { useSearchParams } from '~/hooks/search/useSearchParams';
import { currentSortFieldSelector, searchSortOverrideSelector } from '~/store/configViews/selectors';
import { getAppliedSortField } from '~/store/configViews/utils';

export const useAppliedSortField = () => {
  const currentSortField = useSelector(currentSortFieldSelector);
  const searchSortOverride = useSelector(searchSortOverrideSelector);
  const { hasSearchParams } = useSearchParams();

  const appliedSortField = getAppliedSortField({
    currentSortField,
    hasSearchParams,
    searchSortOverride,
  });

  return {
    appliedSortField,
    appliedSortFieldDirection: appliedSortField?.direction || SortDirection.asc,
    appliedSortFieldName: appliedSortField?.name || 'dateModified',
  };
};
